import { Typography } from '@care/react-component-lib';
import { makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { WhyCareReason } from '../../types/types';

export const useStyles = makeStyles((theme) => ({
  heading: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  article: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },

    '&:not(:last-of-type)': {
      marginBottom: theme.spacing(8),
    },

    [theme.breakpoints.only('md')]: {
      marginLeft: theme.spacing(7),
    },
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
}));

interface WhyCareSectionProps {
  reason: WhyCareReason;
}

const WhyCareSection: FC<WhyCareSectionProps> = ({ reason }) => {
  const classes = useStyles();
  const IconComponent = reason.icon;

  return (
    <article className={classes.article}>
      <div className={classes.iconContainer}>
        <IconComponent size={48} />
      </div>
      <div>
        <Typography variant="h2" component="h4" className={classes.heading}>
          {reason.headline}
        </Typography>
        <Typography variant="body2">{reason.description}</Typography>
      </div>
    </article>
  );
};

export default WhyCareSection;
